
import { Injectable, ViewContainerRef } from '@angular/core';

import { ComponentLoaderService } from '../../componentLoaderService';
import { AppConfiguration } from '../../conf/app.configuration';

// https://www.thisdot.co/blog/loading-components-dynamically-in-angular-9-with-ivy
@Injectable()
export class BasicInfoComponentService {
  constructor(private componentLoaderService: ComponentLoaderService,
    protected appConfig: AppConfiguration) {
  }

  private ProcurementProjectBasicInfoComponent() {
    if ('SARGA' === this.appConfig.getValue('cliente')) {
      return () =>
        import('../../sarga/procurementProject/sargaProcurementProjectBasicInfo.component').then(
          m => m.sargaProcurementProjectBasicInfoComponent
        );
    } else if ('CIXTEC' === this.appConfig.getValue('cliente')
      && true === this.appConfig.getValue('procurementProjectBasicInfo.formMode')) {
      return () =>
        import('../../cixtec/procurementProject/cixtecProcurementProjectBasicInfo.component').then(
          m => m.cixtecProcurementProjectBasicInfoComponent
        );
    }
  }

  private BudgetaryProjectBasicInfoComponent() {
    return () =>
      import('../../sarga/budgetaryProjects/budgetaryProjectBasicInfo.component').then(
        m => m.BudgetaryProjectBasicInfoComponent
      );
  }

  private OrderProjectsBasicInfoComponent() {
    return () =>
      import('../../sarga/orderproject/orderprojectsBasicInfo.component').then(
        m => m.OrderProjectsBasicInfoComponent
      );
  }

  private CompanyProjectBasicInfoComponent() {
    return () =>
      import('../../ril/companyproject.component').then(
        m => m.CompanyProjectComponent
      );
  }

  // private dynamicComponent(component) {
  //   return () =>
  //     import(component).then(
  //       m => m['BudgetaryProjectBasicInfoComponent']
  //     );
  // }

  loadComponent(type: string, vcr: ViewContainerRef, params?: any) {
    vcr.clear();
    let componentBasicInfoData;
    if (type === '00000') {
      componentBasicInfoData = this.ProcurementProjectBasicInfoComponent();
    } else if (type === '03093') {
      componentBasicInfoData = this.BudgetaryProjectBasicInfoComponent();
    } else if (type === '02111') {
      componentBasicInfoData = this.OrderProjectsBasicInfoComponent();
    } else if (type === '00302') {
      componentBasicInfoData = this.CompanyProjectBasicInfoComponent();
    }
    if (componentBasicInfoData) {
      return this.componentLoaderService.forChild(vcr, { loadChildren: componentBasicInfoData }, params);
    } else {
      return null;
    }
  }
}
